import React, { Component } from "react";
import { connect } from 'react-redux';
import {
  activateDevice,
  getStoreInfo,
  updateDeviceInfo,
  updateCurrencyInfo,
} from '../../store/actions';
import { getPopupConfig } from '../../components/Popup';
import { DeviceType } from '../../enums';
import constants from '../../globalization';
import API from '../../requests';
import View from './views';
import util from "../../util";
import { version } from '../../../package.json';
import CustomizationUtil from "../../util/customization-util";

export interface Props {
  dispatchActivateDevice: Function;
  dispatchGetStoreInfo: Function;
  dispatchUpdateDeviceInfo: Function;
  reduxProps: StateType;
}

export interface State {
  activationKey: string;
  popup: PopupContentType | typeof undefined;
}
class ActivateScreen extends Component<Props, State> {
  state = {
    activationKey: '',
    popup: undefined,
  };

  componentDidMount = () => {
    API.setURL(process.env.REACT_APP_IAPI_BASE_URL);
    const { reduxProps, history } = this.props;
    const { deviceApi, storeInfo, deviceInfo } = reduxProps;
    if (deviceApi !== null && storeInfo.data !== null && deviceInfo !== null) {
      if (deviceInfo.deviceTypeId === DeviceType.FIREBOARD_WEBVIEW) {
        history.replace({ pathname: '/fireboard' })
      } else if (deviceInfo.deviceTypeId === DeviceType.TABLE_RESERVATION) {
        history.replace({ pathname: '/tms' })
      } else if (deviceInfo.deviceTypeId === DeviceType.PRINT_SERVER) {
        history.push("/printRequests");
      } else if (deviceInfo.deviceTypeId === DeviceType.KITCHEN_APP) {
        history.push("/kitchen");
      } else if (deviceInfo.deviceTypeId === DeviceType.PAYMENT_AUDIO_JACK) {
        history.push("/serverApp");
      }
    }
  }

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  onPressReset = () => {
    this.setState({ popup: undefined, activationKey: '' });
  };

  handleDeviceActions = deviceApi => {
    const {
      reduxProps: prevReduxProps,
      dispatchGetStoreInfo,
      dispatchUpdateDeviceInfo,
    } = this.props;
    if (deviceApi.timestamp !== prevReduxProps.deviceApi.timestamp) {
      if (deviceApi.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = constants.activationLoadingHeading;
        this.setState({ popup });
      } else if (deviceApi.data) {
        this.closePopup();
        const { deviceExternalId, apiKey, password, deviceId } = deviceApi.data;
        localStorage.setItem('deviceExternalId', deviceExternalId);
        API.setApiHeaders(apiKey, deviceExternalId, password);
        dispatchUpdateDeviceInfo({ deviceExternalId, apiKey, password });
        dispatchGetStoreInfo(deviceId);
      } else if (deviceApi.error) {
        const popup = getPopupConfig('error');
        popup.message = deviceApi.error;
        popup.buttons = [
          { text: constants.retry, onClick: () => this.activateDevice() },
          { text: constants.reset, onClick: () => this.onPressReset() },
        ];
        this.setState({ popup });
      }
    }
  };

  handleStoreActions = (storeInfo, deviceApi) => {
    const { reduxProps: prevReduxProps, dispatchGetStoreInfo } = this.props;
    if (storeInfo.timestamp !== prevReduxProps.storeInfo.timestamp) {
      if (storeInfo.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = constants.activationLoadingHeading;
        this.setState({ popup });
      } else if (storeInfo.data) {
        this.closePopup();
        this.onStoreInfoSuccess(storeInfo.data);
      } else if (storeInfo.error) {
        const popup = getPopupConfig('error', () => {
          dispatchGetStoreInfo(deviceApi?.data?.deviceId);
          this.closePopup();
        });
        popup.message = storeInfo.error;
        this.setState({ popup });
      }
    }
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ reduxProps: { deviceApi, storeInfo } }) {
    this.handleDeviceActions(deviceApi);
    this.handleStoreActions(storeInfo, deviceApi);
  }

  onStoreInfoSuccess = response => {
    const {
      dispatchUpdateDeviceInfo,
      reduxProps: { deviceInfo },
      history,
      dispatchUpdateCurrencyInfo,
    } = this.props;
    dispatchUpdateDeviceInfo({ ...deviceInfo, ...response });
    let countryInfo = {};
    if (response.country === 4) {
      countryInfo = {
        currency: '£',
        iso2: 'GB',
      }
    } else {
      countryInfo = {
        currency: '$',
        iso2: 'US',
      }
    }
    dispatchUpdateCurrencyInfo(countryInfo);
    if (response.deviceTypeId === DeviceType.FIREBOARD_WEBVIEW) {
      history.push("/fireboard");
    } else if (response.deviceTypeId === DeviceType.TABLE_RESERVATION) {
      CustomizationUtil.getCustomizeWaitlist(response?.brandId, 12, () => history.push("/tms"));
    } else if (response.deviceTypeId === DeviceType.PRINT_SERVER) {
      history.push("/printRequests");
    } else if (response.deviceTypeId === DeviceType.KITCHEN_APP) {
      history.push("/kitchen");
    } else if (response.deviceTypeId === DeviceType.PAYMENT_AUDIO_JACK) {
      history.push("/serverApp");
    }
    // history.push("/serverApp");
  };

  activateDevice = () => {
    const { dispatchActivateDevice } = this.props;
    const { activationKey } = this.state;
    let isSimPay = false;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      isSimPay = true;
    }
    const body = {
      activationCode: activationKey,
      uuid: null,
      isSimPay,
      appVersion: version,
    };
    dispatchActivateDevice(body);
  };

  isActivateArrowDisabled = () => {
    const { activationKey } = this.state;
    return !activationKey || activationKey.length < 6;
  };

  handleChange = event => {
    this.setState({ activationKey: event.target.value });
  }

  getProps = () => {
    const { activationKey, popup } = this.state;
    return {
      activationKey,
      popup,
      closePopup: this.closePopup,
      activateDevice: this.activateDevice,
      handleChange: this.handleChange,
      isActivateArrowDisabled: this.isActivateArrowDisabled,
    };
  }

  render() {
    const viewProps = this.getProps();
    return <View {...viewProps} />;
  }
}

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({
  dispatchActivateDevice: payload => {
    dispatch(activateDevice(payload));
  },
  dispatchGetStoreInfo: deviceId => {
    dispatch(getStoreInfo(deviceId));
  },
  dispatchUpdateDeviceInfo: licenseKey => {
    dispatch(updateDeviceInfo(licenseKey));
  },
  dispatchUpdateCurrencyInfo: payload => {
    dispatch(updateCurrencyInfo(payload));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActivateScreen);

